import React from "react";
import { useSelector } from "react-redux";
import { Route, Routes, Outlet, useParams, Navigate } from "react-router-dom";

import { Left } from "pages/Common";
import Mypage from "pages/Mypage";
import Create from "pages/Create";

import Detail from "pages/Detail";
import List from "pages/SheetList";
import Preview from "pages/Preview";
import DiffData from "pages/DiffData";
import MainDesc from "pages/MainDesc";
import PCSGenerator from "pages/PCSGenerator";
import PCSList from "pages/PCSList";
import PCSGeneratorView from "pages/PCSGeneratorView";
import DocPreview from "pages/PCSGenerator/preview";
import Review from "pages/Review";

import DraftSheet from "./DraftSheet";

export const ErrorPage = (props) => {
    const params = useParams();
    return (
        <section className={"maintenance"}>
            <div>
                <h1>Something went wrong.</h1>
                {<p style={{fontSize: "1rem"}}>{params.status}</p>}
            </div>
        </section>
    );
}

const Main = () => {
    return (
        <>
            {/* <Left /> */}
            
            <Routes>
                <Route element={<AuthCheckRouter auth={["1", "2", "3", "4", "20"]} external />}>
                    <Route path="/error" element={<ErrorPage />} />
                    <Route exact path="/" element={<Mypage />} />
                    <Route exact path="/mypage" element={<Mypage />} />
                </Route>

                <Route element={<AuthCheckRouter auth={["1", "2"]} />}>
                    <Route path="/detail" element={<Detail />} />
                    <Route path="/sheetList" element={<List />} />
                    <Route path="/PCSList" element={<PCSList />} />
                    <Route path="/PCSGeneratorView" element={<PCSGeneratorView />} />
                </Route>
                <Route element={<AuthCheckRouter auth={["2"]} />}>                                   
                    <Route path="/mainForm" element={<Create />} />
                    <Route path="/draft-sheet" element={<DraftSheet />} />
                    <Route path="/mainDesc" element={<MainDesc />} />
                    <Route path="/preview" element={<Preview />} />
                    <Route path="/diffData" element={<DiffData />} />
                    <Route path="/PCSGenerator" element={<PCSGenerator />} />

                    <Route
                        path="/PCSGenerator/preview"
                        element={
                            <div className="bpl-container">
                                <DocPreview />
                            </div>
                        }
                    />
                </Route>
                <Route element={<AuthCheckRouter auth={["3"]} external />}>
                    <Route path="/review" element={<Review />} />
                </Route>
                <Route element={<AuthCheckRouter auth={["20"]} external />}>
                    <Route path="/review-ex" element={<Review />} />
                </Route>
                
                <Route path="*" element={<Navigate replace to={"/error/404"} />} />
            </Routes>
        </>
    );
};

const AuthCheckRouter = (props, ref) => {
    const userSelector = useSelector((store) => store.user);
    const check = userSelector?.userAuth?.filter((auth) => props?.auth?.includes(auth.code.toString()));
    const permissions = userSelector?.userAuth?.length > 0;
    const common = useSelector(store => store.common);
    const internal = common.external === "false"
    const isAdmin = userSelector?.isAdmin;
    if (!internal) {
        if (props.external) {
            if (check.length > 0 || isAdmin) {
                return <Outlet />;
            } else {
                return (
                    <div className={"bpl-container text-center"}>
                        <h2>Access Denied</h2>
                        <i>
                            You don't have {permissions ? "any" : ""} permission to access this {permissions ? "page" : "site"}.
                        </i>
                    </div>
                );
            }
        } else {
            return <Navigate replace to={"/error/404"} />
        }
    } else {
        if (check.length > 0 || userSelector.isAdmin) {
            return <Outlet />;
        } else {
            return (
                <div className={"bpl-container text-center"}>
                    <h2>Access Denied</h2>
                    <i>
                        You don't have {permissions ? "any" : ""} permission to access this {permissions ? "page" : "site"}.
                        <br />
                        Please contact BPL Admin.
                    </i>
                </div>
            );
        }
    }
};

export default Main;
